export default __webpack_public_path__ + "static/car-a4e83a96fc461019b695dab2580ff8b9.png";